import React from "react";
import "./TermsConditions.css";

const TermsConditions = () => {
  return (
    <div className="terms-page-container">
      <div className="terms-page-content">
        <h1>Steam and Drive – Terms and Conditions</h1>
        <p className="terms-page-intro">
          By using our steam car wash services, you agree to the following terms
          and conditions:
        </p>
        <div className="terms-page-section">
          <h2>1. Personal Belongings</h2>
          <p>
            The management is not responsible for any loss or damage to personal
            items left inside the vehicle.
          </p>
          <p>
            Customers must ensure all valuables and belongings are removed
            before handing over the vehicle for service.
          </p>
        </div>
        <div className="terms-page-section">
          <h2>2. Customer Conduct</h2>
          <p>
            Customers agree to refrain from interacting with staff during the
            service to maintain safety and efficiency.
          </p>
        </div>
        <div className="terms-page-section">
          <h2>3. Payment Policy</h2>
          <p>
            Cash payments made directly to workers are strictly prohibited. The
            management is not liable for any disputes or issues resulting from
            such transactions.
          </p>
          <p>
            All payments are final and non-refundable. Please verify all service
            details before making a payment.
          </p>
        </div>
        <div className="terms-page-section">
          <h2>4. Paint Protection Film (PPF) Disclaimer</h2>
          <p>
            Customers confirm that their vehicle does not have Paint Protection
            Film (PPF).
          </p>
          <p>
            If PPF is applied, it is the customer's responsibility to obtain a
            written certification from their car service provider, confirming
            that the vehicle is safe for steam washing.
          </p>
        </div>
        <div className="terms-page-section">
          <h2>5. Liability Disclaimer</h2>
          <p>
            While every effort is made to provide a safe and damage-free
            service, Steam and Drive will not be held responsible for any
            pre-existing issues or conditions that may be affected by the steam
            cleaning process.
          </p>
        </div>{" "}
        <div className="terms-page-footer">
          <button
            onClick={() => window.history.back()}
            className="terms-back-button"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
